import CodeMirror from "codemirror";
import "codemirror/addon/edit/matchbrackets";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/clike/clike.js";

$(() => {
    window.codemirror = [];

    $(".code-editor").each(function (index, codeEditorComponent) {
        const obj = $(codeEditorComponent);

        const codeEditorLanguage = obj.data("language");
        const codeEditorReadOnly = obj.data("readonly");

        const visualizationCode = obj.children("textarea.code-container").val();

        // TODO: Modify Visualizations' code directly to apply these changes
        let modifiedCode = visualizationCode.replace(/this\.\$http/, "axios");
        modifiedCode = modifiedCode.replace(/document.getElementById\(\s*["']{1}visualization_container["']{1}\)/, "visualizationContainer[0]");

        const editor = obj.find("textarea.editor");
        editor.val(modifiedCode);

        const cm = CodeMirror.fromTextArea(editor[0], {
            lineNumbers: true,
            theme: "monokai",
            matchBrackets: true,
            mode: codeEditorLanguage,
            indentUnit: 4,
            indentWithTabs: true,
            tabSize: 4,
            lineWrapping: true,
            readOnly: codeEditorReadOnly,
        });

        cm.setSize(null, 480);

        cm.on("change", function (cm, evt) {
            Livewire.emit("codeEditorUpdated");
            if (typeof parent !== "undefined") {
                parent.Livewire.emit("codeEditorUpdated");
            }
        });

        window.codemirror.push(cm);
    });
});
